import { Component, OnInit } from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {RoundOfQuestionsService} from '../../services/round-of-questions.service';
import {RoundOfQuestionsSearch} from '../../models/round-of-questions-search.interface';
import {RoundOfQuestions} from '../../models/round-of-questions.interface';

@Component({
  selector: 'app-round-of-questions',
  templateUrl: './round-of-questions.component.html',
  styleUrls: ['./round-of-questions.component.scss']
})
export class RoundOfQuestionsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  roundOfQuestions!: Page<RoundOfQuestions>;
  search!: RoundOfQuestionsSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'asc'};
  constructor(private readonly roundOfQuestionsService: RoundOfQuestionsService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.roundOfQuestionsService.getAll({status: 'ACTIVE'}, this.page).subscribe(
      data => this.roundOfQuestions = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadRoundOfQuestions(event: PageRequest): void {
    this.page = event;
    this.updateData();
  }

  searchRoundOfQuestions(search: RoundOfQuestionsSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'year', direction: 'asc'};
    }
    this.updateData();
  }

  updateRoundOfQuestionsStatus(id: number): void {
    this.roundOfQuestionsService.updateRoundOfQuestions(id).subscribe(
      () => this.updateData()
    );
  }

  private updateData(): void {
    if (this.search) {
      this.roundOfQuestionsService.getAll(this.search, this.page).subscribe(
        data => this.roundOfQuestions = data
      );
    }
    else {
      this.roundOfQuestionsService.getAll({status: 'ACTIVE'}, this.page).subscribe(
        data => this.roundOfQuestions = data
      );
    }
  }

}
